// action types
export const VIDEOS = "[VIDEOS]";
export const SET_VIDEOS = "SET_VIDEOS";
export const GET_VIDEOS = "GET_VIDEOS";
export const GET_VIDEOS_ID = "GET_VIDEOS_ID";

export const setVideos = payload => ({
  type: `${SET_VIDEOS}`,
  payload
});

export const getVideos = payload => ({
  type: `${GET_VIDEOS}`
});

export const getVideosId = videoId => ({
  type: `${GET_VIDEOS_ID}`,
  videoId
});



// WEBPACK FOOTER //
// ./src/redux/actions/videosActions.js